import { ACTIONS } from '../action/actionTypes'

export const downloadItem = ( state = {}, action ) => {
  switch ( action.type ) {
    case ACTIONS.SET_DOWNLOAD_ITEM_ACTIVE:
      return { ...state, id: action.id };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducer/download_item_reducer.js